/**
 * @desc 平台渠道
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<ObjectMap<string, string>>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/common/platform/channel`, {
      method: "GET",

      ...options,
    }),
  );
}
